// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
// @ vendors
const get = require('lodash/object/get');
const moment = require('moment');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @ actions
const signaturePatternActions = require('actions/signaturePattern');

const cancelCardPayLaterSuccess = () => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_SET_STEP_SUCCESS
});

const cancelCardPayLaterError = () => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_SET_STEP_ERROR
});

const cancelCardPayLaterInfoRequest = () => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_INFORMATION_REQUEST
});

const cancelCardPayLaterInfoSuccess = (response) => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_INFORMATION_SUCCESS,
    payload: {
        movements: get(response, 'methodResult.movimientos["movimiento"][0]'),
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_SET_VISIBLE_STEP,
    payload: { step }
})

const validateStep = (step) => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_VALIDATE_STEP,
    payload: { step }
})

const setWillCancel = (willCancel) => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_WILL_CANCEL,
    payload: { willCancel }
})

const setWillLeave = (willLeave) => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_WILL_LEAVE,
    payload: { willLeave }
})

const reset = () => ({
    type: actionTypes.CANCEL_CARD_PAY_LATER_STEP_RESET
});

const cancelCardPayLaterConfirm = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        var immCard = getState().cards.getIn(['byId', cardId]);
        var numero = getState().cancelCardPayLater.get('numero');
        var tiposit = getState().cancelCardPayLater.get('tiposit');
        var params = {
            query: {
                numerodecontrato: immCard.getIn(['contract', 'number']),
                producto: immCard.getIn(['contract', 'product']),
                dataToken,
                numero,
                tiposit
            }
        };
        dispatch(cancelCardPayLaterInfoRequest());
        return APIPost({
            dispatch,
            endpoint: 'confirmCancelCardPayLater',
            params: params
        })
            .then((response) => dispatch(cancelCardPayLaterSuccess(response)))
            .catch((response) => {
                if (!!response.error) {
                    dispatch(cancelCardPayLaterError(response.error));
                } else {
                    throw response;
                }
            });
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);

}

const requestCancelPayLaterInfo = (cardId) => (dispatch, getState) => {
    const immCard = getState().cards.get('byId').get(cardId);
    const panNumber = getState().cards.getIn(['byId', cardId, 'number']);


    const requestData = {
        query: {
            producto: immCard.getIn(['contract', 'product'], ''),
            numeroDeContrato: immCard.getIn(['contract', 'number'], ''),
            pan: panNumber,
            centro: API_CENTER,
            empresa: API_ENTERPRISE_NUMBER,
            fechaHasta: moment().startOf('day').format(DATE_FORMAT_API),
            fechaDesde: moment().startOf('day').subtract(5, 'year').format(DATE_FORMAT_API),// Need to replace with the correct start date
            sxValue: 'L'
        }
    };

    dispatch(cancelCardPayLaterInfoRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('cancelCardPayLaterInfo'), requestData)
        .then((response) => dispatch(cancelCardPayLaterInfoSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(cancelCardPayLaterError(response.error))
            } else {
                throw response;
            }
        })
};

module.exports = {
    setVisibleStep,
    validateStep,
    cancelCardPayLaterConfirm,
    setWillCancel,
    setWillLeave,
    requestCancelPayLaterInfo,
    reset
}
